import React from 'react';
import PropTypes from 'prop-types';
import { Box, Container, Grid } from '@mui/material';

// Modern layout - with a different arrangement of sections
const ModernLayout = ({ children, sections }) => {
  // Organize sections by their type
  const sectionsByType = sections.reduce((acc, section) => {
    if (!acc[section.type]) {
      acc[section.type] = [];
    }
    acc[section.type].push(section.component);
    return acc;
  }, {});

  return (
    <Box sx={{ width: '100%' }}>
      {/* Hero section at the top - full width */}
      {sectionsByType.hero && sectionsByType.hero.map((Component, index) => (
        <Box key={`hero-${index}`} sx={{ width: '100%' }}>
          <Component />
        </Box>
      ))}
      
      <Container maxWidth="xl" sx={{ py: 6 }}>
        {/* Two column layout for featured properties and about section */}
        <Grid container spacing={4}>
          {/* Left column - Featured properties */}
          <Grid item xs={12} md={8}>
            {sectionsByType.featured && sectionsByType.featured.map((Component, index) => (
              <Box key={`featured-${index}`} sx={{ mb: 6 }}>
                <Component />
              </Box>
            ))}
            
            {/* Recent Blog Posts below featured */}
            {sectionsByType.recentPosts && sectionsByType.recentPosts.map((Component, index) => (
              <Box key={`recentPosts-${index}`} sx={{ mb: 6 }}>
                <Component />
              </Box>
            ))}
            
            {/* Testimonials below recent posts */}
            {sectionsByType.testimonials && sectionsByType.testimonials.map((Component, index) => (
              <Box key={`testimonials-${index}`} sx={{ mb: 6 }}>
                <Component />
              </Box>
            ))}
          </Grid>
          
          {/* Right column - About and Services */}
          <Grid item xs={12} md={4}>
            {/* About section */}
            {sectionsByType.about && sectionsByType.about.map((Component, index) => (
              <Box key={`about-${index}`} sx={{ mb: 6 }}>
                <Component />
              </Box>
            ))}
            
            {/* Services section */}
            {sectionsByType.services && sectionsByType.services.map((Component, index) => (
              <Box key={`services-${index}`} sx={{ mb: 6 }}>
                <Component />
              </Box>
            ))}
          </Grid>
        </Grid>
        
        {/* Any additional sections - full width at the bottom */}
        {sectionsByType.additional && sectionsByType.additional.map((Component, index) => (
          <Box key={`additional-${index}`} sx={{ width: '100%', my: 4 }}>
            <Component />
          </Box>
        ))}
      </Container>
      
      {/* Any custom children */}
      {children}
    </Box>
  );
};

ModernLayout.propTypes = {
  children: PropTypes.node,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      component: PropTypes.elementType.isRequired
    })
  ).isRequired
};

ModernLayout.defaultProps = {
  children: null,
  sections: []
};

export default ModernLayout;
